<template lang="pug">
  include ./../../../../mixins
  +b.stats
    +e.header
      +b.ug-row--apearance_spaced.--space_xs.--justify_between.--align_center
        +b.ug-cell
          +b.TEXT-BEMTO(
            :fw="'bold'"
            :lh="'initial'"
            :fs="['md', '1md-md', 'xl-fhd']"
            :color="'black'"
            :tag="'p'"
          ) USEFUL PHONE NUMBERS
        +b.ug-cell
          +b.stats__icon.icon--type_stats-phone
    +e.body
      +e.content.ma--b_md.--b_1md-lg
        +b.ma--b_xs.TEXT-BEMTO(
          :fw="'medium'"
          :lh="'initial'"
          :fs="['1xs']"
          :color="'grey4'"
          :tag="'p'"
        ) {{ objectItem.scheduleTechnician }}
        +b.c--hover_common.LINK-BEMTO(
          :fw="'medium'"
          :lh="'initial'"
          :fs="['1md', 'xl-lg']"
          :color="'black'"
          :href="'tel:' + objectItem.contactTechnician"
          :tag="'a'"
        ) {{ objectItem.nameTechnician }} - {{ objectItem.contactTechnician }}
      +e.content
        +b.ma--b_xs.TEXT-BEMTO(
          :fw="'medium'"
          :lh="'initial'"
          :fs="['1xs']"
          :color="'grey4'"
          :tag="'p'"
        ) {{ objectItem.scheduleOffice }}
        +b.c--hover_common.LINK-BEMTO(
          :fw="'medium'"
          :lh="'initial'"
          :fs="['1md', 'xl-lg']"
          :color="'black'"
          :href="'tel:' + objectItem.contactOffice"
          :tag="'a'"
        ) {{ objectItem.contactOffice }}
</template>

<script>
export default {
  name: 'NumbersPanel',
  props: [
    'objectItem',
  ],
}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/cabinets/panels/NumbersPanel.vue